<template>
  <div class="container">
    <!--banner-->
    <div class="nban pc">
      <img src="@/view/images/y49.jpg" />
      <div class="nbana nbana_xl">
        <!-- <p class="on"><a href="xs_l.html">印刷管理培训</a></p>
        <p><a href="xs_l.html">印刷技术培训</a></p>
        <p><a href="xs_l.html">管理咨询</a></p>
        <p><a href="xs_l.html">学员天地</a></p> -->
        <div class="clearfix"></div>
      </div>
    </div>
    <!-- <div class="mbx pc">
      <div class="commen">
        <p>位置：<a href="#">首页</a> &gt; <a href="#">学习园地</a></p>
      </div>
    </div> -->
    <!--印刷管理培训列表页-->
    <div class="neiy">
      <!-- <div class="commen">
        <div class="nbana nbana_xl mob">
          <p class="on"><a href="xs_l.html">印刷管理培训</a></p>
          <p><a href="xs_l.html">印刷技术培训</a></p>
          <p><a href="xs_l.html">管理咨询</a></p>
          <p><a href="xs_l.html">学员天地</a></p>
          <div class="clearfix"></div>
        </div> -->
      <!-- <div class="bt reveal-acatop">
          <h6>印刷管理培训</h6>
          <img src="@/view/images/y8.png">
        </div> -->
      <!-- <div class="xlla">
          <div class="fa1fc fl reveal-acatop" v-for="(item,index) in coursesarr" :key="index" @click="buycourses(item.id)">
            <a href="javascript:void(0);">
              <div class="fa1fc_t">
                <img src="@/view/images/y36.jpg">
                <p>立即学习</p>
              </div>
              <div class="fa1fc_w">
                <h6>{{item.courseName}}</h6>
                <p>{{item.courseDescription}}</p>
                <h5 class="lv">{{item.coursePrice | price}}</h5>
                <span>6课时</span>
                <div class="clearfix"></div>
              </div>
            </a>
          </div> -->
      <!--<div class="fa1fc fl reveal-acatop" @click="buycourses(1)">-->
      <!--<a href="javascript:void(0);">-->
      <!--<div class="fa1fc_t">-->
      <!--<img src="@/view/images/y37.jpg">-->
      <!--<p>立即学习</p>-->
      <!--</div>-->
      <!--<div class="fa1fc_w">-->
      <!--<h6>印厂5S管理培训</h6>-->
      <!--<p>课程简介/达成能力/简单标语/课程内容等等......</p>-->
      <!--<h5 class="ju">免费</h5>-->
      <!--<span>6课时</span>-->
      <!--<div class="clearfix"></div>-->
      <!--</div>-->
      <!--</a>-->
      <!--</div>-->
      <!--<div class="fa1fc fl reveal-acatop" @click="buycourses(1)">-->
      <!--<a href="javascript:void(0);">-->
      <!--<div class="fa1fc_t">-->
      <!--<img src="@/view/images/y38.jpg">-->
      <!--<p>立即学习</p>-->
      <!--</div>-->
      <!--<div class="fa1fc_w">-->
      <!--<h6>精益生产</h6>-->
      <!--<p>课程简介/达成能力/简单标语/课程内容等等......</p>-->
      <!--<h5 class="ju">免费</h5>-->
      <!--<span>6课时</span>-->
      <!--<div class="clearfix"></div>-->
      <!--</div>-->
      <!--</a>-->
      <!--</div>-->
      <!--<div class="fa1fc fl reveal-acatop" @click="buycourses(1)">-->
      <!--<a href="javascript:void(0);">-->
      <!--<div class="fa1fc_t">-->
      <!--<img src="@/view/images/y50.jpg">-->
      <!--<p>立即学习</p>-->
      <!--</div>-->
      <!--<div class="fa1fc_w">-->
      <!--<h6>绩效管理</h6>-->
      <!--<p>课程简介/达成能力/简单标语/课程内容等等......</p>-->
      <!--<h5 class="lv">免费</h5>-->
      <!--<span>6课时</span>-->
      <!--<div class="clearfix"></div>-->
      <!--</div>-->
      <!--</a>-->
      <!--</div>-->
      <!--<div class="fa1fc fl reveal-acatop" @click="buycourses(1)">-->
      <!--<a href="javascript:void(0);">-->
      <!--<div class="fa1fc_t">-->
      <!--<img src="@/view/images/y51.jpg">-->
      <!--<p>立即学习</p>-->
      <!--</div>-->
      <!--<div class="fa1fc_w">-->
      <!--<h6>印厂5S管理培训</h6>-->
      <!--<p>课程简介/达成能力/简单标语/课程内容等等......</p>-->
      <!--<h5 class="ju">免费</h5>-->
      <!--<span>6课时</span>-->
      <!--<div class="clearfix"></div>-->
      <!--</div>-->
      <!--</a>-->
      <!--</div>-->
      <!--<div class="fa1fc fl reveal-acatop" @click="buycourses(1)">-->
      <!--<a href="javascript:void(0);">-->
      <!--<div class="fa1fc_t">-->
      <!--<img src="@/view/images/y52.jpg">-->
      <!--<p>立即学习</p>-->
      <!--</div>-->
      <!--<div class="fa1fc_w">-->
      <!--<h6>精益生产</h6>-->
      <!--<p>课程简介/达成能力/简单标语/课程内容等等......</p>-->
      <!--<h5 class="lv">免费</h5>-->
      <!--<span>6课时</span>-->
      <!--<div class="clearfix"></div>-->
      <!--</div>-->
      <!--</a>-->
      <!--</div>-->
      <!--<div class="fa1fc fl reveal-acatop" @click="buycourses(1)">-->
      <!--<a href="javascript:void(0);">-->
      <!--<div class="fa1fc_t">-->
      <!--<img src="@/view/images/y36.jpg">-->
      <!--<p>立即学习</p>-->
      <!--</div>-->
      <!--<div class="fa1fc_w">-->
      <!--<h6>印前色彩管理</h6>-->
      <!--<p>课程简介/达成能力/简单标语/课程内容等等......</p>-->
      <!--<h5 class="lv">免费</h5>-->
      <!--<span>6课时</span>-->
      <!--<div class="clearfix"></div>-->
      <!--</div>-->
      <!--</a>-->
      <!--</div>-->
      <!--<div class="fa1fc fl reveal-acatop" @click="buycourses(1)">-->
      <!--<a href="javascript:void(0);">-->
      <!--<div class="fa1fc_t">-->
      <!--<img src="@/view/images/y37.jpg">-->
      <!--<p>立即学习</p>-->
      <!--</div>-->
      <!--<div class="fa1fc_w">-->
      <!--<h6>印厂5S管理培训</h6>-->
      <!--<p>课程简介/达成能力/简单标语/课程内容等等......</p>-->
      <!--<h5 class="ju">免费</h5>-->
      <!--<span>6课时</span>-->
      <!--<div class="clearfix"></div>-->
      <!--</div>-->
      <!--</a>-->
      <!--</div>-->
      <!--<div class="fa1fc fl reveal-acatop" @click="buycourses(1)">-->
      <!--<a href="javascript:void(0);">-->
      <!--<div class="fa1fc_t">-->
      <!--<img src="@/view/images/y38.jpg">-->
      <!--<p>立即学习</p>-->
      <!--</div>-->
      <!--<div class="fa1fc_w">-->
      <!--<h6>精益生产</h6>-->
      <!--<p>课程简介/达成能力/简单标语/课程内容等等......</p>-->
      <!--<h5 class="lv">免费</h5>-->
      <!--<span>6课时</span>-->
      <!--<div class="clearfix"></div>-->
      <!--</div>-->
      <!--</a>-->
      <!--</div>-->
      <!-- <div class="clearfix"></div>
        </div> -->
      <!-- <div class="ym reveal-acatop" style="display: none;">
          <p class="a"><a href="#">首页</a></p>
          <p class="a"><a href="#">上一页</a></p>
          <p class="on"><a href="#">1</a></p>
          <p><a href="#">2</a></p>
          <p><a href="#">...</a></p>
          <p><a href="#">6</a></p>
          <p class="a"><a href="#">下一页</a></p>
          <p class="a"><a href="#">末页</a></p>
        </div>
        <div class="ym reveal-acatop">
          <el-pagination
            background
            @current-change="handleCurrentChange"
            :current-page.sync="currentPage"
            :page-size="10"
            layout="prev, pager, next"
            :total="Pagenum">
          </el-pagination>
        </div> -->
      <!-- </div> -->
      <div class="xllb">
        <div class="commen">
          <div class="bt reveal-acatop">
            <h6>印刷行业资深导师编排课程</h6>
            <img src="@/view/images/y8.png" />
          </div>
          <div class="xllba reveal-acatop">
            <div
              class="xllba_a fl"
              :class="mouse == 1 ? 'on' : ''"
              @mouseenter="mouseenter(1)"
            >
              <img src="@/view/images/y55.jpg" />
              <p><span>王强</span>色彩管理专家</p>
              <div class="clearfix"></div>
            </div>
            <div
              class="xllba_a fl"
              :class="mouse == 2 ? 'on' : ''"
              @mouseenter="mouseenter(2)"
            >
              <img src="@/view/images/y56.jpg" />
              <p><span>孙智峰</span>智能制造专家</p>
              <div class="clearfix"></div>
            </div>

            <div
              class="xllba_a fl"
              :class="mouse == 4 ? 'on' : ''"
              @mouseenter="mouseenter(4)"
            >
              <img src="@/view/images/y54.jpg" />
              <p><span>薛世儒</span>应用系统专家</p>
              <div class="clearfix"></div>
            </div>
            <div
              class="xllba_a fl "
              :class="mouse == 3 ? 'on' : ''"
              @mouseenter="mouseenter(3)"
            >
              <img src="@/view/images/y53.jpg" />
              <p><span>陈珉</span>视觉机器人专家</p>
              <div class="clearfix"></div>
            </div>
            <div class="clearfix"></div>
          </div>
          <div class="xllbb reveal-acatop">
            <div class="xllbc" v-if="mouse == 3">
              <div class="xllbc_t fl"><img src="@/view/images/y57.jpg" /></div>
              <div class="xllbc_w fr">
                <h5>陈&emsp;珉<span>Chen Min</span></h5>
                <h6>海归专业人才+垂直领域专家</h6>
                <div class="xllbc_wx">
                  <div class="xllbc_wa">
                    <span>荣誉 |</span>
                    <p>
                      ⊙觉机器人专家<br />⊙英国诺丁汉大学计算机图形处理博士<br />⊙中国光电博览会高峰论坛（CIOE）专家委员会委员
                    </p>
                    <div class="clearfix"></div>
                  </div>
                  <br />
                  <div class="xllbc_wa">
                    <span>介绍 |</span>
                    <p>
                      自主研发视觉系统深度学习机器人，擅长视觉传感器与智能识别，算法领域的研发，掌握多项国家专利核心技术
                    </p>
                    <div class="clearfix"></div>
                  </div>
                </div>
              </div>
              <div class="clearfix"></div>
              <div class="xllbc_k">视觉机器人专家</div>
            </div>
            <div class="xllbc" v-else-if="mouse == 4">
              <div class="xllbc_t fl"><img src="@/view/images/y59.jpg" /></div>
              <div class="xllbc_w fr">
                <h5>薛世儒<span>xue shi ru</span></h5>
                <h6>40余年行业经验+英国伦敦大学硕士+印刷系统应用专家</h6>
                <div class="xllbc_wx">
                  <div class="xllbc_wa">
                    <span>荣誉 |</span>
                    <p>
                      ⊙印刷系统应用专家
                      <br />⊙国际软件专家，香港金豪系统创世人
                      <br />⊙英国伦敦大学计算机工程硕士，英国Watford印刷工业学院学士
                      <br />⊙英国、美国、香港印刷商会会员，香港职业训练局委员，香港印艺学会永远资深顾问
                    </p>
                    <div class="clearfix"></div>
                  </div>
                  <br />
                  <div class="xllbc_wa">
                    <span>介绍 |</span>
                    <p>
                      服务全球印刷行业40余年，专注于行业痛点的解决方案及先进技术工具的推广和分享。
                    </p>
                    <div class="clearfix"></div>
                  </div>
                </div>
              </div>
              <div class="clearfix"></div>
              <div class="xllbc_k">应用系统专家</div>
            </div>
            <div class="xllbc" v-else-if="mouse == 1">
              <div class="xllbc_t fl"><img src="@/view/images/y58.jpg" /></div>
              <div class="xllbc_w fr">
                <h5>王强<span>wang qiang</span></h5>
                <h6>色彩管理专家，印刷专家、二级教授、博导</h6>
                <div class="xllbc_wx">
                  <div class="xllbc_wa">
                    <span>荣誉 |</span>
                    <p>
                      <br />⊙杭州电子科技大学特聘教授、武汉大学教授、天津科技大学客座教授、北京印刷学院兼职教授，上海理工大学兼职教授、南京林业大学、大连工业大学兼职教授
                      <br />⊙中国印刷科学技术研究院特聘研究员、国际ISO
                      TC130注册专家、国际G7认证专家、国家科学技术奖评审专家
                      <br />⊙中国环境科学学会绿色包装委员会副理事长、中国印刷技术协会常务理事、中国数字印刷协会副会长
                      <br />⊙中国印刷工业与器材协会专家、亚洲印刷大奖赛独立评审专家、中华印制大奖赛评审专家、金光印艺大奖赛资深评审专家
                      <br />⊙《中国印刷与包装研究》/《数码印刷》/《印刷杂志》编委
                      <br />⊙2011获“亚洲印刷终身成就奖”，2017年获“中华印刷杰出人物奖”。
                    </p>
                    <div class="clearfix"></div>
                  </div>
                  <br />
                  <div class="xllbc_wa">
                    <span>介绍 |</span>
                    <p>
                      从事印刷教育与科研36年，指导博士、硕士研究生120余人，公开出版《分色原理与方法》、《印刷媒体技术手册》等17部著作，发表论文150余篇，承担了国家科技支撑计划等30余项国家和省部级科研项目，获得20项国家发明专利。
                    </p>
                    <div class="clearfix"></div>
                  </div>
                </div>
              </div>
              <div class="clearfix"></div>
              <div class="xllbc_k">色彩管理专家</div>
            </div>
            <div class="xllbc" v-else>
              <div class="xllbc_t fl"><img src="@/view/images/y60.jpg" /></div>
              <div class="xllbc_w fr">
                <h5>孙智峰<span>sun zhi feng</span></h5>
                <h6>南京大学博导+精益生产专家+流程再造专家</h6>
                <div class="xllbc_wx">
                  <div class="xllbc_wa">
                    <span>荣誉 |</span>
                    <p>
                      ⊙全球智能制造产业联盟成员<br />⊙南京大学博导+精益生产专家+流程再造专家，生产智能制造专家
                    </p>
                    <div class="clearfix"></div>
                  </div>
                  <br />
                  <div class="xllbc_wa">
                    <span>介绍 |</span>
                    <p>
                      擅长制造行业企业运作，物流领域商务智能，系统建模，建构设计，需求分析，流程再造
                      <br />曾获南京大学优秀教师鹰松奖
                      <br />中国高新技术博览会银奖、第八届中国北京国际科技产业博览会优秀发明人
                      <br />中国南京全国高新技术博览会银奖（1995）
                      <br />淮安市科学技术进步三等奖（1996）
                      <br />第八届中国北京国际科技产业博览会优秀发明人（2005）。
                    </p>
                    <div class="clearfix"></div>
                  </div>
                </div>
              </div>
              <div class="clearfix"></div>
              <div class="xllbc_k">智能制造专家</div>
            </div>
          </div>
        </div>
      </div>
      <div class="xllc">
        <div class="commen">
          <div class="bt reveal-acatop">
            <h6>流程化课程设计 理论与实操结合</h6>
            <img src="@/view/images/y8.png" />
          </div>
          <div class="xllca reveal-acatop">
            <div class="xllca_a fl">
              <img src="@/view/images/y61.png" />
              <p>01.<br />理论体系搭建</p>
            </div>
            <div class="xllca_b fl"><img src="@/view/images/y66.png" /></div>
            <div class="xllca_a fl">
              <img src="@/view/images/y62.png" />
              <p>02.<br />课程章节编排</p>
            </div>
            <div class="xllca_b fl"><img src="@/view/images/y66.png" /></div>
            <div class="xllca_a fl">
              <img src="@/view/images/y63.png" />
              <p>03.<br />试题内容设计</p>
            </div>
            <div class="xllca_b fl"><img src="@/view/images/y66.png" /></div>
            <div class="xllca_a fl">
              <img src="@/view/images/y64.png" />
              <p>04.<br />课程作业实操</p>
            </div>
            <div class="xllca_b fl"><img src="@/view/images/y66.png" /></div>
            <div class="xllca_a fl">
              <img src="@/view/images/y65.png" />
              <p>05.<br />课程反馈优化</p>
            </div>
            <div class="clearfix"></div>
          </div>
          <div class="xlld">
            <div class="xlld_t fr reveal-acaright">
              <img src="@/view/images/y61.jpg" />
            </div>
            <div class="xlld_w fl reveal-acatop">
              <h5>课程全程跟踪</h5>
              <h6>关注知识 提升技能</h6>
              <img src="@/view/images/y32.png" />
              <p>课前跟踪了解<br />课中积极协助解决<br />课后贴心咨询</p>
            </div>
            <div class="clearfix"></div>
          </div>
          <div class="xlld">
            <div class="xlld_t fl reveal-acaleft">
              <img src="@/view/images/y62.jpg" />
            </div>
            <div class="xlld_w fr xlld_wa reveal-acatop">
              <h5>企业专项培训</h5>
              <h6>助力企业专业化人才培养</h6>
              <img src="@/view/images/y32.png" />
              <p>理论知识辅导</p>
              <p>课程实操跟踪</p>
              <p>疑问难点讨论</p>
              <p>学习路线搭建</p>
            </div>
            <div class="clearfix"></div>
          </div>
        </div>
      </div>
    </div>
    <!--留言-->
    <coun-sel></coun-sel>
    <!-- <div class="lyan reveal-acatop">
      <div class="commen">
        <h6>给印工社留言，免费获取更多服务</h6>
        <div class="lyana">
          <input class="input1 fl" v-model="gongsi" type="text" onfocus="if(value=='您的公司') {value=''}"
                 onblur="if (value=='') {value='您的公司'}">
          <input class="input1 fl" v-model="mobile" type="text" onfocus="if(value=='您的联系方式') {value=''}"
                 onblur="if (value=='') {value='您的联系方式'}">
          <textarea class="fl" v-model="content" onfocus="if(value=='您的需求'){value=''}"
                    onblur="if (value ==''){value='您的需求'}"></textarea>
          <input class="input2 fl" type="submit" value="提交留言">
          <div class="clearfix"></div>
        </div>
      </div>
    </div> -->
  </div>
</template>
<script>
var _hmt = _hmt || [];
(function() {
  var hm = document.createElement("script");
  hm.src = "https://hm.baidu.com/hm.js?0fb0c350f1482064e25902f9db8dec76";
  var s = document.getElementsByTagName("script")[0];
  s.parentNode.insertBefore(hm, s);
})();
</script>
<script>
import $ from 'jquery'; // 在需要使用的页面中
import Swiper from 'swiper';
import 'swiper/dist/css/swiper.min.css';
import CounSel from '@/components/counsel';

export default {
  name: 'academicName',
  components: {
    CounSel,
  },
  filters: {
    price(pri) {
      let name;
      if (pri === 0) {
        name = '免费';
      } else {
        name = `￥${pri}`;
      }
      return name;
    },
  },
  data() {
    return {
      content: '您的需求',
      mobile: '您的联系方式',
      gongsi: '您的公司',
      currentPage: 1,
      Pagenum: 0,
      coursesarr: '',
      mouse: 1,
    };
  },
  mounted() {},
  methods: {
    init() {
      this.courseslist();
    },
    mouseenter(id) {
      const _this = this;
      _this.mouse = id;
    },
    // 购买课程
    buycourses(id) {
      this.$router.push({ path: `/buycourses?id=${id}` });
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.currentPage = val;
    },
    courseslist() {
      const _this = this;
      const currentPage = _this.currentPage - 1;
      const url = `${process.env.API_HOST}/portal/course?count=10&page=${currentPage}`; // HOME变量为已挂载的可跨域域名，这里将其拼接完，成为一个完整路径
      this.$axios({
        // this代表vue对象，之前在入口文件中把axios挂载到了vue中，所以这里直接用this.$axios调用axios对象
        method: 'get',
        url,
        data: {},
      }).then((res) => {
        const json = res.data;
        if (json.code === 200) {
          const { data } = json.message;
          _this.Pagenum = data.totalCount;
          _this.coursesarr = data.list;
        }
      });
    },
  },

  created() {
    const _this = this;
    _this.init();
  },
};
</script>

<style scoped>
.neiy {
  margin: 0;
}
.xllb {
  margin: 0;
}
</style>



// WEBPACK FOOTER //
// src/view/academic.vue